import Image from 'next/image';

import classNames from 'classnames';

import { calcPercentage } from '../../utils/helper';

import styles from './ProductCard.module.scss';

function ProductCard({ course, className, showPrice = true, as = 'div', ...props }) {
  // changing the component to the one passed in the as prop
  const Component = as;

  // calculating the discount percentage
  const discountPercentage =
    100 - calcPercentage(Number.parseFloat(course.discountPrice), Number.parseFloat(course.basePrice));

  const showDiscountBadge = course.discountPrice > 0;

  return (
    <Component className={classNames(styles.wrapper, className)} {...props}>
      {showDiscountBadge && <span className={styles.discountBadge}>{discountPercentage}% OFF</span>}

      <div className={styles.thumbnailWrapper}>
        <Image src={course.thumbnailUrl} alt={course.title} sizes="25rem" fill />
      </div>

      {/* <div className={styles.languagesWrapper}>
        <span className={styles.language}>HINDI</span>
        <span className={styles.language}>English</span>
      </div> */}

      <h4 className={styles.title}>{course.title || 'No Title'}</h4>

      {showPrice && course.discountPrice > 0 ? (
        <div className={styles.priceWrapper}>
          <span className={styles.discountedPrice}>₹{course.discountPrice}</span>
          <span className={styles.netPrice}>₹{course.basePrice}</span>
        </div>
      ) : (
        <div className={styles.priceWrapper}>
          <span className={styles.freeCourseLabel}>FREE</span>
        </div>
      )}

      <button type="button" className={styles.buyNowBtn}>
        BUY NOW
      </button>
    </Component>
  );
}

export default ProductCard;
